module.exports = __webpack_public_path__ + "media/images/icons/ic-warning-1b658fe3e31a5869b81dbaf51578d727.svg";